const zhCategory = {
  'starScandal.title': '明星丑闻 · 全网追踪',
  'starScandal.subtitle': '演员歌手综艺咖塌房全记录，从顶流到老戏骨一网打尽',
  'influencer.title': '网红塌房 · 翻车现场',
  'influencer.subtitle': '直播带货翻车、人设崩塌、假吃真面目全解析',
  'leakedChats.title': '泄露聊天 · 实锤对话',
  'leakedChats.subtitle': '原汁原味的聊天记录曝光，给你最真实的吃瓜体验',
  'contrastVideo.title': '反差视频 · 真实面目',
  'contrastVideo.subtitle': '人前光鲜人后反差，揭露他们不为人知的一面',
  'filter.latest': '最新',
  'filter.hottest': '最热',
  'subscribe.title': '订阅<span class="italic font-light text-foreground-400">本分类更新</span>',
  'subscribe.btn': '打开通知',
};

export default zhCategory;